/**
 * Module dependencies.
 */

import { compact } from 'lodash';

/**
 * Export `getPathSegments`.
 */

export function getPathSegments(path: string): Array<string> {
  return path.split('/').filter((segment) => segment);
}

/**
 * Export `resolvePathParts`.
 */

export function resolvePathParts(path: string): Array<string> {
  if (Array.isArray(path)) {
    return path;
  }

  const [mainPath, ...subPaths] = compact(path.split('/'));

  return [mainPath ?? '', ...subPaths];
}
